module.exports = __webpack_public_path__ + "img/1721784409456-WhatsApp Image 2024-07-24 at 09.24.57 1.jpeg.bfee396d.webp";